
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"loading-template\">\n  <div class=\"error\"></div>\n  <div class=\"spinner\"></div>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  